import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=497106b6&scoped=true&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497106b6",
  null
  
)

export default component.exports